import * as ActivityState from 'entities/lifecycle/activityState';
import { RulesetSplitTest } from 'entities/rulesetSplitTest';
import { State } from 'store';
import { Actions as RestActions, Sagas as RestSagas, Selectors as RestSelectors } from './rest';
import { Sagas as RulesetSplittestSagas, updateRulesetSplitTest } from './updateSplitTestSaga';

export const Selectors = {
  ...RestSelectors,
  otherSplitTests: (state: State, splitTestId: string): RulesetSplitTest[] =>
    RestSelectors.getEntityIds(state)
      .filter((x: string) => x !== splitTestId)
      .map((x: string) => RestSelectors.getEntity(state, x)),
  getActiveSplitTestsForCampaign: (state: State, campaignId: string): RulesetSplitTest[] =>
    RestSelectors.getEntities(state).filter(
      splitTest => splitTest.campaignId === campaignId && ActivityState.getActivityState(splitTest) === 'Live',
    ),
};

export const Actions = {
  ...RestActions,
  updateRulesetSplitTest,
};

export const Sagas = [...RestSagas, ...RulesetSplittestSagas];
